import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

class Navigation extends Component {
    state = {  }
    render() { 
        return ( 
        <Navbar bg="dark" variant='dark' collapseOnSelect fixed='top' size='sm' >
          <Navbar.Brand href="/places">geomphotography.com</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              {/* <Nav.Link href="/people">People</Nav.Link> */}
              <Nav.Link href="/places">Places</Nav.Link>
              <Nav.Link href="/events">Events</Nav.Link>
              <Nav.Link href="/models">Models</Nav.Link>
              <Nav.Link href="/stock">Stock</Nav.Link>
              <Nav.Link href="/street">Street</Nav.Link>
              {/* <Nav.Link href="/s3">S3</Nav.Link> */}
              <NavDropdown title="RoadTrips" id="basic-nav-RoadTrips">
                <NavDropdown.Item href="/NewYork">New York</NavDropdown.Item>
                <NavDropdown.Item href="/zion">Zion</NavDropdown.Item>
                <NavDropdown.Item href="/badlands">Badlands-Arches-Rushmore</NavDropdown.Item>
                <NavDropdown.Item href="/yellowstone">Yellowstone</NavDropdown.Item>
                <NavDropdown.Item href="/canyonlands">CanyonlandsNP</NavDropdown.Item>
                <NavDropdown.Item href="/bryce">BryceCanyons</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="grandTeton">Grand Teton</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar> 
        );
    }
}
 
export default Navigation;